import React from "react";
import { View, StyleSheet } from "react-native";
import { Text, Cover, Separator, Button } from "components";

import { colors, sizes } from "assets/constants";
import { factorItemsAtom } from "stores";
import { useRecoilValue } from "recoil";
import { persianDigit } from "utils";
import tinycolor from "tinycolor2";
import css from "styles";

type DraftItemsProps = {
  setIndexToBeRemoved: (key: number) => void;
};

const DraftItems: React.FC<DraftItemsProps> = ({ setIndexToBeRemoved }) => {
  const factorItems = useRecoilValue(factorItemsAtom);

  return (
    <View style={css.fitWidth}>
      <Separator
        weight={2}
        color={colors.lightBorder}
        spaces={{ bottom: sizes.space }}
      />
      <View style={{ marginTop: 10, marginBottom: 5 }}>
        <Text color={colors.text.muted} weight={"extraBold"}>
          محصولات موجود در بخش ثبت سفارش
        </Text>
      </View>
      <View style={css.responsiveListContainer}>
        {factorItems?.filter((e) => e?.status?.priority === 1)?.length === 0 ? (
          <Text color={colors.text.muted}>
            محصولی در بخش ثبت سفارش وجود ندارد
          </Text>
        ) : (
          factorItems?.map((item: FactorItemT, key: number) => {
            const _goToRemove = () => setIndexToBeRemoved(key);

            if (item?.status?.priority !== 1) {
              return null;
            }

            return (
              <View key={String(key)} style={css.responsiveInputContainer}>
                <View key={String(key)} style={styles.box}>
                  <Button
                    onPress={_goToRemove}
                    square={35}
                    style={{ marginRight: sizes.space }}
                    icon={{ name: "trash", color: colors.danger }}
                    bgColor={tinycolor(colors.danger).lighten(42).toString()}
                  />

                  {item?.item_description ? (
                    <View
                      style={{
                        flex: 1,
                        padding: sizes.space / 2,
                        marginHorizontal: sizes.space,
                        backgroundColor: tinycolor(colors.theme)
                          .lighten(52)
                          .toString(),
                      }}
                    >
                      <Text>{item?.item_description}</Text>
                    </View>
                  ) : (
                    <>
                      <Button
                        disabled
                        square={35}
                        bgColor={tinycolor(colors.theme).lighten(52).toString()}
                        title={{
                          top: 2,
                          size: "xl",
                          weight: "extraBold",
                          value: `${item?.count}`,
                        }}
                      />

                      <Cover />
                    </>
                  )}

                  <View>
                    <Text weight="bold" size={"xs"} color={colors.text.muted}>
                      {" "}
                      {item?.category?.title}
                    </Text>

                    <Text weight="extraBold" size={"sm"}>
                      {" "}
                      {item?.product?.title}
                    </Text>

                    <View style={styles.row}>
                      {item?.attributes
                        ?.map((e) => e.title)
                        ?.map((t, key: number) => (
                          <Text key={String(key)}> {persianDigit(t)} </Text>
                        ))}
                    </View>
                  </View>
                </View>
                {item?.product?.is_binary === 1 && (
                  <View
                    style={{
                      position: "absolute",
                      top: -2,
                      left: 2,
                      borderWidth: 1,
                      paddingHorizontal: 12,
                      borderRadius: 10,
                      backgroundColor: colors.white,
                      borderColor: colors.lightBorder,
                    }}
                  >
                    <Text
                      top={-1}
                      weight="extraBold"
                      color={colors.darkWarning}
                    >
                      جفتی
                    </Text>
                  </View>
                )}
              </View>
            );
          })
        )}
      </View>
    </View>
  );
};

export default DraftItems;

const styles = StyleSheet.create({
  box: {
    width: "100%",
    height: 80,
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 5,
    alignSelf: "center",
    paddingRight: 10,
    paddingLeft: sizes.space,
    borderWidth: 1,
    borderColor: colors.lightBorder,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.white,
  },

  row: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
});
